/*
Copyright 2018 OCAD University

Licensed under the Educational Community License (ECL), Version 2.0 or the New
BSD license. You may not use this file except in compliance with one these
Licenses.

You may obtain a copy of the ECL 2.0 License and BSD License at
https://github.com/fluid-project/infusion/raw/master/Infusion-LICENSE.txt
*/

var fluid_3_0_0 = fluid_3_0_0 || {};

(function (fluid) {
    "use strict";

    /*******************************************************************************
    * Starter auxiliary schema grade
    *
    * Contains the settings for captions
    *******************************************************************************/

    // Fine-tune the starter aux schema and add captions panel
    fluid.defaults("fluid.prefs.auxSchema.captions", {
        gradeNames: ["fluid.prefs.auxSchema"],
        auxiliarySchema: {
            "namespace": "fluid.prefs.constructed",
            "terms": {
                "templatePrefix": "../../framework/preferences/html",
                "messagePrefix": "../../framework/preferences/messages"
            },
            "template": "%templatePrefix/SeparatedPanelPrefsEditor.html",
            "message": "%messagePrefix/prefsEditor.json",

            captions: {
                type: "fluid.prefs.captions",
                enactor: {
                    type: "fluid.prefs.enactor.captions",
                    container: "body"
                },
                panel: {
                    type: "fluid.prefs.panel.captions",
                    container: ".flc-prefsEditor-captions",
                    template: "%templatePrefix/PrefsEditorTemplate-captions.html",
                    message: "%messagePrefix/captions.json"
                }
            }
        }
    });


    /*******************************************************************************
    * Primary Schema
    *******************************************************************************/

    // add extra prefs to the starter primary schemas

    fluid.defaults("fluid.prefs.schemas.captions", {
        gradeNames: ["fluid.prefs.schemas"],
        schema: {
            "fluid.prefs.captions": {
                "type": "boolean",
                "default": false
            }
        }
    });

})(fluid_3_0_0);
